import { classNames } from '@/util/tailwindHelpers'
import styles from './body.module.scss'

const ModalBody = ({ children, className, title, titleClassName }) => {
  return (
    <div
      className={classNames(className, 'pb-[var(--modalBodyBottomPadding)]')}
    >
      {title && (
        <h2
          className={classNames(
            titleClassName ? titleClassName : 'h4',
            styles.content_title,
            'mb-3'
          )}
        >
          {title}
        </h2>
      )}
      {children}
    </div>
  )
}

export default ModalBody
